"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireWildcard(require("./_base"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var fontWeights = _objectSpread(_objectSpread({}, _base["default"].fontWeights), {}, {
  bold: 700,
  headings: 700,
  h2: 700,
  h3: 700
});
var iconSizes = _objectSpread(_objectSpread({}, _base["default"].iconSizes), {}, {
  menu: "18px"
});
var menu = _objectSpread(_objectSpread({}, _base["default"].menu), {}, {
  pH: _base["default"].spaces.s,
  // for items - mandatory
  pV: _base["default"].spaces.s,
  // for items - mandatory
  mH: _base["default"].spaces.s,
  // for items - mandatory
  mV: _base["default"].spaces.s,
  // for items - mandatory
  fontSize: _base["default"].fontSizes.base,
  logo: "30px",
  openWidth: "240px"
});
var buttons = _objectSpread(_objectSpread({}, _base["default"].buttons), {}, {
  primary: {
    color: "primary"
  },
  secondary: {
    variant: "shadowHover",
    color: "border",
    textColor: "text"
  },
  tertiary: {
    variant: "transparent"
  },
  iconButton: {
    textColor: "text"
  },
  danger: {
    variant: "filled",
    color: "error"
  }
});

// TODO: add palette
var palette = {
  blue: "#5693EF",
  blue_1: "#7cb0ff",
  green: "#009E70",
  green_1: "#b1f1d5",
  red: "#FF5D53",
  red_1: "#ffb8b8",
  yellow: "#FBA612",
  yellow_1: "#fdecb9",
  light: "#FFF",
  light_1: "#C2C5DC",
  light_2: "#9DA0B4",
  light_3: "#838D97",
  dark: "#222222",
  dark_1: "#132330",
  dark_2: "#1D2D3D",
  dark_3: "#233547",
  dark_4: "#384858"
};
var newColors = _objectSpread(_objectSpread({}, _base.baseColorTokens), {}, {
  // overwrites
  success: palette.green,
  success_1: palette.green_1,
  warning: palette.yellow,
  warning_1: palette.yellow_1,
  error: palette.red,
  error_1: palette.red_1,
  primary: palette.blue,
  primary_1: palette.blue_1,
  border: palette.dark_4,
  backgroundPrimary: palette.dark_3,
  backgroundSecondary: palette.dark_1,
  backgroundTertiary: palette.dark_2,
  backgroundFourth: palette.dark_4,
  text: palette.light,
  textSecondary: palette.light_2,
  textTertiary: palette.light_3,
  textInverted: palette.dark,
  label: palette.light_3,
  focus: palette.blue,
  inputBackground: palette.dark_1,
  inputButton: palette.light,
  inputIcon: palette.light_3,
  tableHeadText: palette.light_3,
  radioCheckInactive: palette.light_1,
  tagBackground: palette.dark_2,
  menuBackground: palette.dark_3,
  menuSearchBackground: "#1A2735",
  menuSearchText: palette.light,
  menuItem: palette.light_1,
  menuIconActive: palette.light,
  menuBackgroundActive: "#1A2735",
  palette: _objectSpread({}, palette)
});
var realtimeTheme = _objectSpread(_objectSpread({}, _base["default"]), {}, {
  fontWeights: fontWeights,
  iconSizes: iconSizes,
  menu: menu,
  buttons: buttons,
  colors: newColors,
  borderRadius: _objectSpread(_objectSpread({}, _base["default"].borderRadius), {}, {
    xs: "2px",
    // tooltip
    s: "2px",
    // badge small
    base: "6px"
  })
});
var _default = realtimeTheme;
exports["default"] = _default;